

export const ParamGroupType = {
    /**
     * 环境
     */
    ENVIRONMENT: 1,
    /**
     * 整体
     */
    WHOLE: 2,
    /**
     * 构件
     */
    COMPONENT: 3,
    /**
     * 节点
     */
    NODE: 4,
    /**
     * 零部件
     */
    PATRS: 5,
    /**
     * 设备
     */
    DEVICE: 6,
}

export const ParamGroupTypeOption = [
    { label: "环境", type: ParamGroupType.ENVIRONMENT },
    { label: "整体", type: ParamGroupType.WHOLE },
    { label: "构件", type: ParamGroupType.COMPONENT },
    { label: "节点", type: ParamGroupType.NODE },
    { label: "零部件", type: ParamGroupType.PATRS },
    { label: "设备", type: ParamGroupType.DEVICE },
]

export const ParamType = {
    /**
     * 常数
     */
    CONSTANT: 1,
    /**
     * 库
     */
    LIBRARY: 2,
    /**
     * 计算
     */
    CALCULATION: 3,
    /**
     * 设备采集
     */
    COLLECTION: 4

}

export const ParamTypeOption = [
    { label: "常数", value: ParamType.CONSTANT },
    { label: "库", value: ParamType.LIBRARY },
    { label: "计算", value: ParamType.CALCULATION },
    { label: "设备采集", value: ParamType.COLLECTION },
]

export const getParamTypeName = (paramType: number) => {
    if (paramType == ParamType.CONSTANT) {
        return "常数"
    } else if (paramType == ParamType.LIBRARY) {
        return "库"
    } else if (paramType == ParamType.CALCULATION) {
        return "计算"
    } else if (paramType == ParamType.COLLECTION) {
        return "设备采集"
    }
    return "-"
}